export let itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: {id: 0, sku_code: '', article_name: '', unit_name: ''},
    physical_stock_in_hand: 0,
    system_stock_in_hand: 0,
    adjustment_qty: 0,
    item_edit: 0
}

export let dataProps = {
    id: 0,
    store_id: null,
    stock_update_date: new Date(), 
    generated_by_staff_id: 0, 
    approved_by_staff_id: 0,
    approval_notes: '',
    status: 0, 
    
    item_list: [JSON.parse(JSON.stringify(itemListProps))],
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryStockCheck/properties.js